<template>
  <div class="pratos-container" :class="{'visible':visible}">
    <div class="pt-header">
      <span v-text="$t('plate')"></span>
      <span v-text="$t('minimum_month')"></span>
      <span v-text="$t('maximum_month')"></span>
      <span v-text="$t('maximum_week')"></span>
      <span v-text="$t('cost_unit')"></span>
      <span v-text="$t('per_capita_average')"></span>
      <span v-text="$t('incidence')"></span>
    </div>
    <div class="pt-body">
      <div class="pratos" v-for="pratos in pratoList" :class="{lackOfCost: lackOfCost(pratos)}" :title="showError(pratos)">
        <span v-text="pratos.nm_prato" :title="getPlateTitle(pratos)"></span>
        <span v-text="pratos.freq.qt_min_mes || '--'"></span>
        <span v-text="pratos.freq.qt_max_mes || '--'"></span>
        <span v-text="pratos.freq.qt_max_sem || '--'"></span>
        <span v-text="'R$ ' + parseFloat(pratos.vlr_prato).toFixed(5).replace('.', ',').replace(/([0-9]{3}),([0-9]{5}$)/g, '.$1,$2')"></span>
        <span v-text="'R$ ' + parseFloat(pratos.vlr_pu).toFixed(5).replace('.', ',').replace(/([0-9]{3}),([0-9]{5}$)/g, '.$1,$2')"></span>
        <span v-text="pratos.qt_utilizado"></span>
      </div>
    </div>
  </div>
</template>

<script>

import { t } from 'i18next'

export default {
  name: "AnalResultPrato",
  props: ["pratoList", "visible"],
  data() {
    return {};
  },
  methods: {
    showError: function(data){
      if(this.lackOfCost(data)){
        return t('dish_without_cost_or_with_outdated_cost');
      }
      return null;
    },
    lackOfCost: function(data){
      return data.id_prato_sem_custo;
    },
    getPlateTitle: function(prato){
      let desc = `${prato.nm_prato} \n`;
      desc += `${prato.nm_tipocorte ? t('TP_CUT') + prato.nm_tipocorte + "\n" : ""}`;
      desc += `${prato.nm_modopreparo ? t('PREPARATION_MODE') + prato.nm_modopreparo + "\n" : "" }`;
      desc += `${prato.nm_ingrediente_1? t('ing_main_1') + ": " + prato.nm_ingrediente_1 + "\n": ""}`;
      desc += `${prato.nm_ingrediente_2 ? t('ing_main_2') + ": " + prato.nm_ingrediente_2 + "\n": ""}`;
      return desc;
    }
  },
  watch: {
    visible: function() {
      this.visible;
    }
  }
};
</script>

<style scoped lang="less">
@import (reference) url("../../assets/variables.less");
.pratos-container {
  font-size: 13px;
  .sombra;
}
.pt-header {
  background: @azul;
  color: #fff;
  display: grid;
  grid-template-columns: 21% 13% 13% 13% 13% 13% 13%;
  span:first-of-type {
    padding-left: 5px;
    margin: auto 0;
  }
  span:not(:first-of-type) {
    text-align: center;
    padding-left: 5px;
    display: table;
    margin: auto;
  }
}
.pt-body {
  max-height: 200px;
  overflow: auto;
  .pratos {
    &:nth-of-type(2n) {
      background: rgba(196, 196, 196, 0.2);
    }
    display: grid;
    grid-template-columns: 21% 13% 13% 13% 13% 13% 13%;
    span {
      padding: 5px 0;
    }
    span:first-of-type {
      padding-left: 5px;
      font-size: 13px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    span:not(:first-of-type) {
      text-align: center;
    }
  }
  .lackOfCost{
    color:red;
  }
}
</style>